import {Injectable} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {Demokratiewerkstatt} from "../models/demokratiewerkstatt.model";
import {Project} from "../models/project.model";
import {HttpRequestsConfigService} from "./http-requests-config.service";

@Injectable({
  providedIn: 'root'
})
export class DemokratiewerkstattService {
  demokratiewerkstatt: Demokratiewerkstatt[] = [];

  demokratiewerkstatt$: Subject<Demokratiewerkstatt[]> = new Subject<Demokratiewerkstatt[]>();

  constructor(private httpRequestConfig: HttpRequestsConfigService) {
  }

  emitDemokratiewerkstattSubject() {
    this.demokratiewerkstatt$.next(this.demokratiewerkstatt as Array<Demokratiewerkstatt>);
  }

  public getWorkshops() {
    this.emitDemokratiewerkstattSubject();
    this.httpRequestConfig.getAll<Demokratiewerkstatt>('/demokratiewerkstatt').subscribe(
      (response) => {
        this.demokratiewerkstatt = (response as any).demokratiewerkstatt;
        console.log('response', response);
        this.emitDemokratiewerkstattSubject();
      }
    );
  }

  public getDemokratiewerkstatt(project_id: number): Observable<Demokratiewerkstatt> {
    return this.httpRequestConfig.get<Demokratiewerkstatt>('/demokratiewerkstatt', project_id);
  }

  public editProject(projectId: number, project: Demokratiewerkstatt): Observable<Demokratiewerkstatt> {

    return this.httpRequestConfig.put<Demokratiewerkstatt>('/demokratiewerkstatt/update', projectId, project);
  }

  public deleteProject(projectId: number) {
    return this.httpRequestConfig.delete<Project>('/demokratiewerkstatt/delete', projectId);
  }

  public convertStringToArray(inputString: any) {
    const trimmedString = inputString.trim();

    if (trimmedString.startsWith('[') && trimmedString.endsWith(']')) {
      const stringWithoutBrackets = trimmedString.slice(1, -1);

      const stringArray = stringWithoutBrackets.split(',');

      const resultArray = stringArray.map((element: any) => `${element.trim().slice(1, -1)}`);

      return resultArray;
    } else {
      return [];
    }
  }

  public createDemokratiewerkstatt(project: Demokratiewerkstatt): Observable<Demokratiewerkstatt> {

    return this.httpRequestConfig.post<Demokratiewerkstatt>('/demokratiewerkstatt/add', project);
  }
}
